/**
 * 校园卡挂失
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import './CardLose.css';
import {Modal, Picker, List, Toast} from 'antd-mobile';
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import RosterBean from "../../model/RosterBean";
import {getArrayValue, getIntValue, getStrValue, isObjEmpty} from "../../utils/common";
import ReactDOM from "react-dom";
import CardLoseItem from '../../components/CardLoseItem';
import {saveClassData} from "../../redux/actions/classData";
import {saveListState} from "../../redux/actions/listState";
import ClassBean from '../../model/ClassBean'
import {Icon,Button} from "antd";
import ic_open from '../../style/imgs/ic_card_open.png';
import ic_lock from '../../style/imgs/ic_card_lock.png';

const { alert } = Modal

class CardLose extends Component {

    constructor(props) {
        super(props);
        this.state = {
            curDayData: [],
            classList: [],
            albumList: [],
            classValue: [],
            cardState: true,
            cardType: 1,
            changType: 1,
        }
    }
    componentDidMount() {
        document.title = '校园卡挂失';
        this.container.scrollIntoView();
        if(this.props.userInfo.userRole===2){
            this.getClassList()
        }else if(this.props.userInfo.userRole===1){
            this.getPayState()
        }
    }

    getPayState = () => {
          let stuId = '10097'
          if (this.props.userInfo.parent != null) {
            if (this.props.userInfo.parent.student != null) {
              if (this.props.userInfo.parent.student.stuId != null) {
                stuId = this.props.userInfo.parent.student.stuId
                Toast.loading('')
                fetchGet(API.GET_CARD_STATE, {
                  stuId: stuId,
                }).then((response) => {
                  Toast.hide()
                  console.log('response:' + JSON.stringify(response))
                  if (response.success) {
                    this.setState({
                      cardState: response.data.cardState,
                      cardType: response.data.cardType,
                      changType: response.data.changType,
                    })
                  }

                }).catch((error) => {
                  Toast.hide()
                  console.log('error:' + JSON.stringify(error))
                })
              }
            }
          }

    }


    render() {
        const {
            albumList, classList, classValue
        } = this.state;
        let albumItems = []
        if (!isObjEmpty(albumList)) {
            for (let i = 0; i < albumList.length; i++) {
                const albumBean = albumList[i]
                if (!isObjEmpty(albumBean)) {
                    albumItems.push(
                        <CardLoseItem
                            albumBean={albumBean}
                            itemClick={this.onRosterItemClick.bind(this)}
                            index={i}
                            key={albumBean.stuId}/>
                    )
                }
            }
        }

        return (
            <div ref={node => this.container = node} style={{height: '100vh', overflow: 'scroll'}}>
                <div className='gray-line'></div>
                {this.props.userInfo.userRole===2?<div>
                <Picker data={classList} title='选择班级' extra='请选择'
                        value={classValue} onChange={this.handleClassChange} cols={1}>
                    <List.Item arrow="horizontal">选择班级</List.Item>
                </Picker>
                <div className='gray-line'></div>

                <div className='search-bar-root'>
                    <div className='search-bar-layout' onClick={this.toSearchPage.bind(this, 1)}>
                        <Icon type="search"/>
                        <span style={{paddingLeft: '10px'}}>请输入学生姓名</span>
                    </div>
                </div>
                <div className='gray-line' style={{height: '1px'}}></div>
                <div className="header_days_sty">
                <div className={'each_day_default'}>
                    姓名
                </div>
                <div className={'each_day_default'}>
                    卡状态
                </div>
                <div className={'each_day_default'}>
                    操作
                </div>
                </div>

                    {albumItems}

                </div>
                :
                <div className=" flex_column">
                      <div className="flex_column_center bg_light_green">
                        <div className=" flex_column_center padding_20">
                          {this.state.cardState ?
                            <img
                              className="img_right"
                              src={ic_open}
                              width={40}
                              height={40}/> : <img className="img_right"
                                                   src={ic_lock} width={40}
                                                   height={40}/>
                          }
                          <div className="text_white span_16 margin_top_5">{this.props.userInfo.parent.student.stuName}</div>
                          <div className="text_white span_16 margin_top_5">{this.state.changType===0?'已挂失':this.state.changType===1 && (this.state.cardType===0 || this.state.cardType===1)?'挂失中':'使用中'}</div>
                        </div>
                      </div>
                      <div className="flex_column  padding_10">
                        <div className="text_bold">挂失</div>
                            <div className="flex  margin_top_10">
                              <Button className="item_flex_1" disabled={!this.state.cardState}
                              onClick={() => {this.onClickIcCard()}}>
                              <span className="margin_10">挂失</span></Button>
                            </div>
                      </div>

                      <div className="div-long-text padding_10">
                        <div className="span_15 text_bold">温馨提醒:</div>
                        <div className="div-long-text margin_top_10">
                          校园卡挂失后，请到学校补卡处补卡或解挂^_^
                        </div>
                      </div>
                    </div>
                    }
            </div>
        )
    }

    onClickIcCard () {

        const { userInfo } = this.props
        alert('', '确认挂失当前卡吗？挂失后卡片将无法进行消费', [
          {
            text: '取消', onPress: () => {
            },
          },
          {
            text: '确定', onPress: () => {
                let stuId = '10097'
                if (this.props.userInfo.parent != null) {
                  if (this.props.userInfo.parent.student != null) {
                    if (this.props.userInfo.parent.student.stuId != null) {
                      stuId = this.props.userInfo.parent.student.stuId
                    }
                  }
                }
                Toast.loading('')
                fetchPost(API.STUDENTS_CARD_LOSE, {
                  stuId: stuId,
                }).then((response) => {
                  Toast.hide()
                  console.log('response:' + JSON.stringify(response))
                  if (response.success) {
                    Toast.show(response.data)
                    this.setState({
                      cardState: false,
                    })
                  } else {
                    Toast.fail(response.message, 2)
                  }
                  /*this.backTask = setTimeout(() => {
                      this.props.history.goBack()
                  }, 1000)*/
                }).catch((error) => {
                  Toast.hide()
                  console.log('error:' + JSON.stringify(error))
                })
            },
          },
        ])
      }

    toSearchPage = (role) => {
        const {classList, classValue} = this.state
        if (role === 1) {
            this.props.history.push('/cardSearch/teacher/'+classList[classValue].schId)
        } else if (role === 2) {
            this.props.history.push('/cardSearch/parent/'+classList[classValue].schId)
        }
    }

    getClassList = () => {
        const {classList, classValue} = this.state
        classList.length = 0
        let userRole = this.props.userInfo.userRole;
        let params, url
        if (userRole == 1) {
            url = API.GET_STU_CLASS_LIST
            params = {
                stuId: this.props.userInfo.user.student.stuId
            }
        } else {
            url = API.GET_SCHOOL_LIST
            params = {
                schoolId: this.props.userInfo.user.schoolId,
                teacherId: this.props.userInfo.user.userFunId
            }
        }
        fetchGet(url, params).then(response => {
            Toast.hide()
            this.analysisClassList(response)
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('班级获取异常', 2)
            }
        })
    }

    analysisClassList = response => {
        const {classList, classValue} = this.state
        classList.length = 0
        classValue.length = 0

        let dataArray = response.data
        if (dataArray) {
            for (let i = 0; i < dataArray.length; i++) {
                let dataObject = dataArray[i]
                if (dataObject) {
                    let classBean = new ClassBean()

                    classBean.label = getStrValue(dataObject, 'gradeName') + getStrValue(dataObject, 'clazzName')
                    classBean.value = i
                    classBean.schId = getStrValue(dataObject, 'clazzId')
                    classBean.parentId = getStrValue(dataObject, 'gradeId')
                    classBean.schName = getStrValue(dataObject, 'clazzName')
                    classBean.schStatus = getStrValue(dataObject, 'clazzStatus')
                    classBean.schRemarks = getStrValue(dataObject, 'clazzRemarks')
                    classBean.grade = getStrValue(dataObject, 'gradeName')

                    classList.push(classBean)
                }
            }

            if (classList.length > 0) {
                classValue.push(classList[0].value)
                this.setState({
                    classList,
                    classValue
                })

                Toast.loading('学生名单...', 0)
                this.getAlbumList(classList[0])
            }
        }
    }

    onRosterItemClick = (index) => {

    }

    handleClassChange = (v) => {
        this.setState({classValue: v})
        if(v.length>0){
            this.getAlbumList(this.state.classList[v])
        }
    }

    getAlbumList = classBean => {

        fetchPost(API.GET_ROSTER_LIST, {
            clazzId: classBean.schId,
            pageIndex: 1,
            pageSize: 100,
        }).then(response => {
            Toast.hide()

            const rosterList = [];
            let dataArray = response.data
            if (dataArray) {
                let total = dataArray.length;
                for (let i = 0; i < dataArray.length; i++) {
                    let dataObject = dataArray[i]
                    if (dataObject) {
                        let albumBean = new RosterBean()
                        albumBean.stuId = getIntValue(dataObject, 'stuId')
                        albumBean.stuName = getStrValue(dataObject, 'stuName')
                        albumBean.changType = getStrValue(dataObject, 'changType')===1 && dataObject.stuTeacherCard !==null && (getIntValue(dataObject, 'stuTeacherCard')===1 || getIntValue(dataObject, 'stuTeacherCard')===0)?"挂失中":
                            getStrValue(dataObject, 'changType')===1?'正常': getStrValue(dataObject, 'changType')===0?'已挂失':'无卡'

                        rosterList.push(albumBean)
                    }
                }

                this.setState({
                    albumList: rosterList,
                })
            }
        }).catch(error => {
            Toast.hide()
            if (typeof error === 'string') {
                Toast.fail(error)
            }
        })
    }

}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
    listState: {...state.redListState}
});

let mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CardLose)